// extracted by mini-css-extract-plugin
export var checkbox = "_8h-0";
export var circle = "_8h-3";
export var horizontalContainer = "_8h-7";
export var sm = "_8h-5";
export var switch0 = "_8h-2";
export var switchDisabled = "_8h-8";
export var switchEnabled = "_8h-1";
export var textSwitchContainer = "_8h-9";
export var textSwitchOption = "_8h-a";
export var textSwitchOptionSelected = "_8h-b";
export var verticalContainer = "_8h-6";
export var xs = "_8h-4";